import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { campaigns } from '../lib/mockData';
import { Plus, Calendar, Settings, ChevronRight } from 'lucide-react';
export function Campaigns() {
  return <div className="space-y-8" data-id="element-108">
      <div className="flex items-center justify-between" data-id="element-109">
        <div data-id="element-110">
          <h1 className="text-2xl font-bold text-stone-900" data-id="element-111">Campaigns</h1>
          <p className="text-stone-500 mt-1" data-id="element-112">
            Configure testing windows and letter schedules.
          </p>
        </div>
        <Button icon={<Plus size={20} data-id="element-114" />} data-id="element-113">New Campaign</Button>
      </div>

      <div className="grid grid-cols-1 gap-6" data-id="element-115">
        {campaigns.map(campaign => <Card key={campaign.id} className="group hover:border-teal-200 transition-colors" data-id="element-116">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-117">
              <div className="flex-1" data-id="element-118">
                <div className="flex items-center gap-3 mb-2" data-id="element-119">
                  <h3 className="text-lg font-semibold text-stone-900" data-id="element-120">
                    {campaign.name}
                  </h3>
                  <Badge variant={campaign.status === 'Active' ? 'success' : campaign.status === 'Completed' ? 'neutral' : 'warning'} data-id="element-121">
                    {campaign.status}
                  </Badge>
                </div>

                <div className="flex flex-wrap gap-6 text-sm text-stone-600" data-id="element-122">
                  <div className="flex items-center gap-2" data-id="element-123">
                    <Calendar size={16} className="text-stone-400" data-id="element-124" />
                    <span data-id="element-125">
                      Window:{' '}
                      <span className="font-medium text-stone-900" data-id="element-126">
                        {campaign.windowStart} - {campaign.windowEnd}
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-127">
                    <Mail size={16} className="text-stone-400" data-id="element-128" />
                    <span data-id="element-129">
                      Letters:{' '}
                      <span className="font-medium text-stone-900" data-id="element-130">
                        {campaign.lettersScheduled}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-131">
                <div className="text-right hidden md:block" data-id="element-132">
                  <div className="text-2xl font-bold text-stone-900" data-id="element-133">
                    {campaign.studentsCount.toLocaleString()}
                  </div>
                  <div className="text-xs text-stone-500" data-id="element-134">
                    Students Included
                  </div>
                </div>
                <div className="h-10 w-px bg-stone-200 hidden md:block" data-id="element-135"></div>
                <div className="flex gap-2" data-id="element-136">
                  <Button variant="outline" size="sm" icon={<Settings size={16} data-id="element-138" />} data-id="element-137">
                    Configure
                  </Button>
                  <Button variant="ghost" size="sm" data-id="element-139">
                    <ChevronRight size={20} data-id="element-140" />
                  </Button>
                </div>
              </div>
            </div>

            {/* Progress Bar for Active Campaigns */}
            {campaign.status === 'Active' && <div className="mt-6 pt-6 border-t border-stone-100" data-id="element-141">
                <div className="flex justify-between text-sm mb-2" data-id="element-142">
                  <span className="text-stone-600" data-id="element-143">Testing Progress</span>
                  <span className="font-medium text-teal-700" data-id="element-144">
                    {campaign.completionRate}% Complete
                  </span>
                </div>
                <div className="w-full h-2 bg-stone-100 rounded-full overflow-hidden" data-id="element-145">
                  <div className="h-full bg-teal-500 rounded-full transition-all duration-1000" style={{
              width: `${campaign.completionRate}%`
            }} data-id="element-146"></div>
                </div>
              </div>}
          </Card>)}
      </div>

      {/* Configuration Preview Section */}
      <div className="mt-12" data-id="element-147">
        <h2 className="text-lg font-semibold text-stone-900 mb-4" data-id="element-148">
          Global Settings
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-149">
          <Card className="cursor-pointer hover:border-teal-300" data-id="element-150">
            <div className="p-2 bg-teal-50 w-fit rounded-lg text-teal-600 mb-4" data-id="element-151">
              <Settings size={24} data-id="element-152" />
            </div>
            <h3 className="font-semibold text-stone-900 mb-2" data-id="element-153">
              Grade Level Thresholds
            </h3>
            <p className="text-sm text-stone-500 mb-4" data-id="element-154">
              Define the Lexile ranges for "On Track", "Approaching", and "Needs
              Support" for each grade level.
            </p>
            <span className="text-teal-600 text-sm font-medium hover:underline" data-id="element-155">
              Manage Thresholds →
            </span>
          </Card>

          <Card className="cursor-pointer hover:border-teal-300" data-id="element-156">
            <div className="p-2 bg-coral-50 w-fit rounded-lg text-coral-600 mb-4" data-id="element-157">
              <Mail size={24} data-id="element-158" />
            </div>
            <h3 className="font-semibold text-stone-900 mb-2" data-id="element-159">
              Letter Templates
            </h3>
            <p className="text-sm text-stone-500 mb-4" data-id="element-160">
              Customize the content, tone, and branding of the letters sent to
              families.
            </p>
            <span className="text-teal-600 text-sm font-medium hover:underline" data-id="element-161">
              Edit Templates →
            </span>
          </Card>
        </div>
      </div>
    </div>;
}
// Helper component for icon
function Mail({
  size,
  className
}: {
  size: number;
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-162">
      <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-163" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-164" />
    </svg>;
}